import { MessageBannersBox } from "@amzn/it-shop-shared-components";
import { MessageBannerType } from "@amzn/stencil-react-components/message-banner";
import styled from "@emotion/styled";
import React, { FC } from "react";
import { SERVICE_ISSUE_TICKET_URL } from "../../constants/external-links.constants";
import { MessageBanner, useNotificationStore } from "../../stores/use-notification-store";
import { getString } from "../../uistringlabels/ui-string-utils";

const BANNER_TYPES: Record<MessageBanner["type"], MessageBannerType> = {
  error: MessageBannerType.Error,
  success: MessageBannerType.Success,
  warning: MessageBannerType.Warning,
  informational: MessageBannerType.Informational,
};

/**
 * The shared banner box is fixed to the window by default; this keeps it in the page flow, where
 * the page places it.
 */
const InPageBanners = styled.div({
  "& .message-banners-box-col": {
    position: "static",
    width: "100%",
  },
});

const BANNER_STRINGS = {
  persistMessage: getString("notificationBanners.persistMessage"),
  ctiLinkLabel: getString("notificationBanners.ctiLinkLabel"),
};

export const NotificationBanners: FC = () => {
  const banners = useNotificationStore((state) => state.banners);
  const removeBanner = useNotificationStore((state) => state.removeBanner);

  if (banners.length === 0) {
    return null;
  }

  return (
    <InPageBanners data-testid="notification-banners">
      <MessageBannersBox
        messages={banners.map((banner) => ({
          id: banner.id,
          message: banner.message,
          type: BANNER_TYPES[banner.type] ?? MessageBannerType.Informational,
          cti: banner.cti,
        }))}
        onRemove={removeBanner}
        strings={BANNER_STRINGS}
        ctiUrl={SERVICE_ISSUE_TICKET_URL}
      />
    </InPageBanners>
  );
};
